import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Schema } from '../create/components/serie-form.schema';
import { SerieForm } from '../create/components/serie-form';
import { useUpdateSeriesMutation } from '../mutations';
import { useSerieDetailsQuery } from '../queries';
import { seriesIdParamSchema } from '~/schemas';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';

export function Page() {
  const { seriesId } = useParams(seriesIdParamSchema.parse);
  const { data } = useSerieDetailsQuery(seriesId);
  const mutation = useUpdateSeriesMutation();
  const navigate = useNavigate();

  async function onSubmit(payload: Schema) {
    await toast.promise(mutation.mutateAsync({ id: seriesId, payload }), {
      success: 'Serien har uppdaterats',
      pending: 'Uppdaterar serien...',
    });
    navigate(-1);
  }

  if (!data) return false;
  return (
    <Fragment>
      <PageLayout.Heading text="Redigera serie" />

      <PageLayout.Section>
        <SerieForm
          onSubmit={onSubmit}
          isLoading={mutation.isPending}
          mode="edit"
          defaultValues={{
            name: data.name,
            year: data.year,
            competition_type: data.competition_type.id,
            gender: data.gender,
            age_categories: data.age_categories.map(ageCategory => ageCategory.id) ?? [],
            scoring_system: data.scoring_system,
          }}
        />
      </PageLayout.Section>
    </Fragment>
  );
}
